module.exports = __webpack_public_path__ + "static/img/dlw_banner.22dae39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/dlw_banner.png
// module id = pZ44
// module chunks = 16